var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "form__group inline-submit" }, [
        _c(
          "label",
          { staticClass: "form__label", attrs: { for: "search_query" } },
          [_vm._v("Link MADD/Opportunity")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.formData.query,
              expression: "formData.query",
            },
            { name: "validate", rawName: "v-validate" },
          ],
          staticClass: "form__control",
          attrs: {
            id: "search_query",
            name: "query",
            placeholder:
              "Search for an existing MADD/Opportunity within this sector...",
            required: "",
            disabled: _vm.$wait.is("search-results"),
          },
          domProps: { value: _vm.formData.query },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "query", $event.target.value)
              },
              _vm.handleTextInput,
            ],
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--icon btn--primary",
            attrs: { disabled: _vm.$wait.is("search-results") },
          },
          [
            _vm.$wait.is("search-results")
              ? _c("Spinner")
              : _c("SvgIcon", {
                  attrs: { icon: "filled-opposearch", classes: "filled" },
                }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form__validation" }),
      ]),
      _vm._v(" "),
      _vm.formData.query && _vm.formData.query.length
        ? _c(
            "div",
            { staticClass: "search-results" },
            [
              _c("v-wait", { attrs: { for: "search-results" } }, [
                !_vm.itemsIsEmpty
                  ? _c(
                      "ul",
                      { staticClass: "search-results__list" },
                      _vm._l(_vm.items, function (item) {
                        return _c(
                          "li",
                          [
                            _c("Result", {
                              attrs: {
                                item: item,
                                "is-selected":
                                  _vm.selectedItem &&
                                  item.id === _vm.selectedItem.id,
                              },
                              on: { "on-selected": _vm.handleSelection },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _c("span", [
                      _vm._v(
                        "\n                No Results Found\n            "
                      ),
                    ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }